// Single file for ALL native Angular component states in the hybrid app. app.module.ts
// passes APP_STATES to `UIRouterUpgradeModule.forRoot({ states })`. For now every migrated
// route is declared inline here; split into co-located `*.states.ts` per feature later if
// this grows.
//
// Legacy AngularJS states still live in configs/states.js (declared via
// `$stateProvider` in an app.config block) until they're migrated; both sets register into
// the same shared ui-router StateRegistry at runtime.
//
// sudo.role / employee.roles render the SAME RoleListComponent with a different default
// `type` (mirrors the pre-migration ng1 states); the component self-sources `type` from
// UIRouterGlobals. The ng1 abstract parents `sudo`/`employee` keep `<div ui-view>` in their
// layout.html; the angular-hybrid `UIViewNgUpgrade` bridge renders the ng2 component into it.
// `data.requireLogin` is read by the ng1 auth guard (index.js onBefore hook), unchanged.
import type { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';
import { RoleListComponent } from './sudo/access/role-list.component';
import { GradeTemplatesListComponent } from './sudo/grade-templates/grade-templates-list.component';

// States are grouped by their parent path part: sudo.* → employee.* → admin.*.
export const APP_STATES: NgHybridStateDeclaration[] = [
    // ---- sudo.* ----
    {
        name: 'sudo.role',
        url: '/roles?type',
        component: RoleListComponent,
        params: { type: { value: 'USER', squash: true } },
        data: { requireLogin: true },
    },
    // Phase 6: grade-templates list. The SAME component is also mounted under admin.* below;
    // the still-ng1 `*.grade-template-edit` page stays in configs/states.js, and the component's
    // edit() resolves `^.grade-template-edit` relative to whichever parent is active.
    {
        name: 'sudo.grade-templates',
        url: '/grade-templates',
        component: GradeTemplatesListComponent,
        data: { requireLogin: true },
    },

    // ---- employee.* ----
    {
        name: 'employee.roles',
        url: '/roles?type',
        component: RoleListComponent,
        params: { type: { value: 'DOCFLOW', squash: true } },
        data: { requireLogin: true },
    },

    // ---- admin.* ----
    {
        name: 'admin.grade-templates',
        url: '/grade-templates',
        component: GradeTemplatesListComponent,
        data: { requireLogin: true },
    },
];
